import {Kalender, RechteService, Role} from 'kkm-library';
import {Injectable, inject, signal} from '@angular/core';
import {lastValueFrom} from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class KalenderService {
    private rechteService = inject(RechteService);

    constructor() {
        this.loadRolelist();
    }

    rollen = signal<Role[]>([]);

    async loadRolelist(): Promise<void> {
        this.rollen.set(await lastValueFrom(this.rechteService.getGruppen()));
    }

    /** Get Blueprint eines neuen Kalenders */
    newKalender(): Kalender {
        const kalender: Kalender = {titel: '', farbe: '', oeffentlich: false, rights: []};
        this.rollen().forEach(rolle => {
            kalender.rights!.push({group: rolle.name, read: false, write: false});
        });
        return kalender;
    }
}
